import styled from 'styled-components';

export const Container = styled.div``;

export const ColorsContainer = styled.div`
  position: fixed;
  z-index: 9999999;
  width: 100%;
  top: 0;
  left: 0;
  height: 20px;
  background: linear-gradient(90deg, ${props => props.scale.toString()});
  opacity: 1;
  z-index: 1;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.12);
`;

export const LegendWrapper = styled.div`
  display: flex;
  position: relative;
  top: 3px;
  z-index: 2;
`;

export const Item = styled.div`
  flex: 1;
  color: #fff;
  font-size: 9px;
  text-align: right;
  text-shadow: #000 1px 0px 0px, #000 0.5403px 0.84147px 0px, #000 -0.41615px 0.9093px 0px,
    #000 -0.98999px 0.14112px 0px, #000 -0.65364px -0.7568px 0px, #000 0.28366px -0.95892px 0px,
    #000 0.96017px -0.27942px 0px;
    position: relative;
  span {
    right: 0;
    transform: translateX(50%);
    display: inline-block;
    width: 20px;
    text-align: center;
  }
  &:last-child{
    span{
      display: none;
    }
  }
`;
